import React from 'react';
import './StatusWidget.css';
import { SleepIcon } from './activityShared';
import {
  DASHBOARD_TIPS_PREVIEW_LIMIT,
  FALLBACK_HEALTH_TIPS,
} from './healthInsights';

// Bed glyph for the rest tip — same SleepIcon every other sleep
// affordance uses (Recent Activities, Insights, Quick Actions). The
// previous icon here was a couch SVG drawn inline, which made the same
// "rest" intent look like a different kind of activity.
function RestTipIcon() {
  return <SleepIcon size={22} color="currentColor" />;
}

function WaterTipIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3.75S6.75 9.65 6.75 14.2A5.25 5.25 0 0 0 12 19.45a5.25 5.25 0 0 0 5.25-5.25C17.25 9.65 12 3.75 12 3.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.65 14.45c.25 1.25 1.15 2.05 2.45 2.2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function getTipIcon(tipId) {
  if (tipId === 'stay-hydrated') return <WaterTipIcon />;
  return <RestTipIcon />;
}

export default function StatusWidget() {
  const tips = FALLBACK_HEALTH_TIPS.slice(0, DASHBOARD_TIPS_PREVIEW_LIMIT);

  return (
    <div className="status-widget-content">
      <h3 className="status-widget-title">Health Tips</h3>

      <div className="status-tips-list">
        {tips.map((tip) => (
          <div key={tip.id} className="status-tip-card">
            <div className={`status-tip-icon status-tip-icon--${tip.id}`}>
              {getTipIcon(tip.id)}
            </div>

            <div className="status-tip-copy">
              <h4 className="status-tip-title">{tip.title}</h4>
              <p className="status-tip-desc">{tip.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}